export interface DirectUpload {
  status: 'started' | 'processing' | 'preparing' | 'completed' | 'canceled';
  percentage: number;
}

export interface DirectUploadPulicAssetRes extends DirectUpload {
  publicUrl?: string;
}

export interface GeneralUploadRes extends DirectUpload {
  keyForSignApi: string; // use for sign api
  fileKey: string; // use for download api
}

export interface TempUploadRes extends DirectUpload {
  tempKey: string; // key contain `temp` prefix and can download by general download api
  key: string; //original key without `temp` prefix and can only download with temp download api
  region: string;
  bucket: string;
  scanId?: number;
}

export enum ScaningStatus {
  scanning = 'scanning',
  infected = 'infected',
  clean = 'clean',
  failed = 'failed'
}

export interface UploadToken {
  fileKey: string;
  token: string;
  mediaId?: string;
  orgUuid?: string;
  publicUrl?: string;
}

export interface UploadTokenRes extends DirectUpload {
  fileKey?: string;
  scanId?: number;
  publicUrl?: string;
}

export const Status = {
  STARTED: 'started',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  NONE: undefined
};

export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB
export const MAX_IMAGE_SIZE_WHATSAPP = 5 * 1024 * 1024; // 5MB
export const MAX_VIDEO_SIZE_WHATSAPP = 16 * 1024 * 1024; // 16MB
export const MAX_AUDIO_SIZE_WHATSAPP = 16 * 1024 * 1024; // 16MB
export const MAX_DOC_SIZE_WHATSAPP = 100 * 1024 * 1024; // 100MB

export interface UploadEvent {
  status: string;
  percentage: number;
}
